import { render, staticRenderFns } from "./gymRatingGraphicAvgStudentDeadLift.vue?vue&type=template&id=aa3a36d0&"
import script from "./gymRatingGraphicAvgStudentDeadLift.js?vue&type=script&lang=js&"
export * from "./gymRatingGraphicAvgStudentDeadLift.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports